const $ = require('jquery');
global.$ = global.jQuery = $;
import Alpine from 'alpinejs';
require('slick-carousel');
require('slick-carousel/slick/slick.css');
require('slick-carousel/slick/slick-theme.css');

require('bootstrap');

window.eccube_alpine = Alpine;

// Wait for DOM to be ready before starting Alpine
// if (document.body) {
//     Alpine.start();
// } else {
//     document.addEventListener('DOMContentLoaded', () => {
//         Alpine.start();
//     });
// }
Alpine.start();

// Alpine コンポーネント登録（alpine:init で登録）
import './alpine/search';
import './features/google-analytics-cart';
import './features/naviplus-cart-beacon';
import './features/cart-store-confirm';
